module.exports = __webpack_public_path__ + "img/badge_3feuille@2x.c134eb28.png";